import React from 'react';
import { useTheme } from '@mui/joy';
import { useSelector } from 'react-redux';
import {useNavigate} from "react-router-dom";
import taxonomyNameActions from 'actions/taxonomyNameActions';

import Stack from 'components/core/Stack';
import Typography from 'components/core/Typography';
import Button from 'components/core/Button';
import Sheet from 'components/core/Sheet';
import SearchAutocomplete from 'components/SearchAutocomplete';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

const Dashboard = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const me = useSelector(({ profile }) => profile.me);

    if (!me) {
        return null
    }

    const buttonStyles = {
        height: 100,
        width: 300,
    }

    const buttonIconStyles = {
        fontSize: 40,
        marginTop: 16,
    }

    const handleTaxonomyChange = (taxonomyName) => {
        navigate(`/taxonomy/${taxonomyName.id}`);
    };

    const buttonData = [
        {
            title: 'Add Observation',
            icon: <AddCircleOutlineIcon style={buttonIconStyles}/>,
            callback: () => {navigate('/observation/add')},
        },
        {
            title: 'Find Observations',
            icon: <ManageSearchIcon style={buttonIconStyles}/>,
            callback: () => {navigate('/observation-query')},
        },
        {
            title: 'Observation Import',
            icon: <SaveAltIcon style={buttonIconStyles}/>,
            callback: () => {navigate('/observation/import')},
        },
    ]

    const noOptionComponent = () => {
        if (me.get('type') !== 'ADMIN') {
            return <li>No options</li>
        }
        return (
            <li onClick={() => { navigate('/taxonomy/add') }} style={{cursor: 'pointer'}}>
                <Stack direction="row">
                    <AddCircleOutlineIcon sx={{marginRight: 2, color: 'black'}}/>
                    <Typography>Add New Taxonomy</Typography>
                </Stack>
            </li>
        )
    }
    
    return (
        <Stack
            sx={{
                alignItems: 'center',
                justifyContent: 'center',
                mx: { xs: 1, sm: 1, md: 5, lg: 10, xl: 30 }
            }}
        >
            <Typography variant="h1" sx={{ mb: 2 }}>
                Welcome to BORIIS2
            </Typography>
            <Sheet sx={{ mb: 2, width: '100%', background: 'none', backgroundColor: 'none'}}>
                <Typography variant="bodyLg">
                    The second Biota Of Rhode Island Index System is a guide to evidence about the animals, plants, and other living organisms—the biota—of Rhode Island and its environs. BORIIS2 is based around “Observations” which take the form of the question: “Who saw what species when and where and how do we know?” BORIIS is an index, and where appropriate, users may want to consult the cited evidentiary records directly.
                </Typography>
            </Sheet>
            <Sheet sx={{width: '100%', background: 'none', backgroundColor: 'none'}}>
                <Typography variant="h3" sx={{ mb: 2, width: '100%'}}>
                    Observations
                </Typography>
            </Sheet>
            <Stack
                direction="row"
                spacing={4}
                sx={{ mb: 10 }}
            >
                {buttonData.map(({ title, icon, callback }) => (
                    <Button sx={buttonStyles} onClick={callback}>
                        <Stack
                            direction="row"
                            spacing={5}
                        >
                            {icon}
                            <Typography 
                                style={{
                                    color: 'white', 
                                    fontSize: 22,
                                    fontWeight: '300'
                                }}
                            >
                                {title}
                            </Typography>
                        </Stack>
                    </Button>
                ))}
            </Stack>
            <Sheet sx={{width: '100%', background: 'none', backgroundColor: 'none'}}>
                <Typography variant="h3" sx={{ mb: 2, width: '100%'}}>
                    Taxonomy Lookup
                </Typography>
            </Sheet>
            <SearchAutocomplete
                placeholder="Taxonomy Search"
                onSelect={handleTaxonomyChange}
                searchAction={taxonomyNameActions.search}
                selector={({ taxonomyName }) => taxonomyName.searchResults}
                getOptionLabel={(option) => option.name}
                noOptionComponent={noOptionComponent()}
                noOptionAlwaysVisible={me.get('type') === 'ADMIN'}
                sx={{ mb: 8, width: '50vw' }}
            />

        <img
            src={'./img/undraw_file_searching_re_3evy 1.png'}
            alt={''}
            width={250} 
          />
        </Stack>
    );
};

export default Dashboard;